import { useState, useEffect } from "react";
import { loadIssueIndentList } from "../services/issueIndentService";
import { loadPurchaseIndentList } from "../services/purchaseIndentService";

const usePurchaseIndentList = (Mode) => {
    const [purchasedIndentList, setPurchasedIndentList] = useState([]);
    const [selectPurchasedIndent, setSelectPurchasedIndent] = useState(null);
    const [selectPurchasedIndentID, setSelectPurchasedIndentID] = useState(null);
    const [isPurchasedIndentDataLoaded, setIsPurchasedIndentDataLoaded] = useState(false);

    // Fetch department data
    const fetchPurchasedIndent = async (selectedID = null) => {
        const para = { p_company_id: localStorage.getItem("companyid"), p_plant_id: 1,p_select_status:Mode };

        try {
            const data = await loadPurchaseIndentList(para);
            if (data && data.length > 0) {
                setPurchasedIndentList(data);
                setIsPurchasedIndentDataLoaded(true);
            }
            else
            {
                setPurchasedIndentList([]);
                setIsPurchasedIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isPurchasedIndentDataLoaded) {
            fetchPurchasedIndent();
        }
    }, [isPurchasedIndentDataLoaded]);

    // Function to load department based on selected ID
    const loadPurchasedIndentByID = async (selectedID) => {
        await fetchPurchasedIndent(selectedID);
    };

    return {
        purchasedIndentList,
        setPurchasedIndentList,
        selectPurchasedIndent,
        selectPurchasedIndentID,
        loadPurchasedIndentByID,
    };
};

export default usePurchaseIndentList;
